/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes, { string } from 'prop-types';

const LinkColumn = ({ title, headerTitle, renderForHeader, onClick, className, dataCellClass }) => {
  const titleToRender = typeof title === 'string' ? title : 'Edit';
  const headerTitleToRender = typeof headerTitle === 'string' ? headerTitle : titleToRender;
  const onLinkButtonClicked = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (onClick) onClick();
  };

  if (renderForHeader) {
    return (
      <th scope="col" className={className}>
        {headerTitle && <span>{headerTitleToRender}</span>}
        {!headerTitle && <span className="sr-only">{titleToRender}</span>}
      </th>
    );
  }

  if (typeof title === 'object') {
    return (
      <td className={dataCellClass}>
        {title}
      </td>
    );
  }

  return (
    <td className={dataCellClass}>
      <a href="#" onClick={onLinkButtonClicked} className="text-indigo-600 hover:text-indigo-900">
        {titleToRender}
      </a>
    </td>
  );
};

// https://mparavano.medium.com/find-filter-react-children-by-type-d9799fb78292
LinkColumn.defaultProps = {
  __TYPE: 'LinkColumn',
  title: string,
  children: PropTypes.node,
  onClick: PropTypes.func,
  renderForHeader: PropTypes.bool,
  askForConfirmation: PropTypes.bool,
  confirmationTitle: string,
  confirmationDescription: string,
  // className: string,
  // dataCellClass: string,
};

export { LinkColumn };
